import { http } from 'shared/api/http';

const BASE = '/api/v1/pilates/accounting';

function buildQuery(params = {}) {
  const qs = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      qs.set(key, String(value));
    }
  });

  const query = qs.toString();
  return query ? `?${query}` : '';
}

export const accountingApi = {
  // ---------------- INCOME ----------------

  overview: ({ from, to } = {}) =>
    http(`${BASE}/overview${buildQuery({ from, to })}`, {
      method: 'GET',
      auth: true,
    }),

  income: ({ from, to, trainerId, q, limit = 200 } = {}) =>
    http(`${BASE}/income${buildQuery({ from, to, trainerId, q, limit })}`, {
      method: 'GET',
      auth: true,
    }),

  pendingPayments: ({ from, to, trainerId, q, limit = 200 } = {}) =>
    http(`${BASE}/pending-payments${buildQuery({ from, to, trainerId, q, limit })}`, {
      method: 'GET',
      auth: true,
    }),

  collectedPayments: ({ from, to, trainerId, q, limit = 200 } = {}) =>
    http(`${BASE}/collected-payments${buildQuery({ from, to, trainerId, q, limit })}`, {
      method: 'GET',
      auth: true,
    }),

  expenses: ({ from, to } = {}) =>
    http(`${BASE}/expenses${buildQuery({ from, to })}`, {
      method: 'GET',
      auth: true,
    }),

  createExpense: (payload) =>
    http(`${BASE}/expenses`, {
      method: 'POST',
      auth: true,
      body: payload,
    }),

  markExpensePaid: (expenseId, payload) =>
    http(`${BASE}/expenses/${expenseId}/pay`, {
      method: 'PATCH',
      auth: true,
      body: payload,
    }),

  markExpensePending: (expenseId, payload) =>
    http(`${BASE}/expenses/${expenseId}/pending`, {
      method: 'PATCH',
      auth: true,
      body: payload,
    }),

  deleteExpense: (expenseId) =>
    http(`${BASE}/expenses/${expenseId}`, {
      method: 'DELETE',
      auth: true,
    }),
};
